module.exports = __webpack_public_path__ + "static/media/rom4.e0cde32c.jpg";